/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import {
    object, shape, string, boolean,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import mbpLogger from 'mbp-logger';
// queries
import findURL from '../../../../../gql/queries/findURL';
import customBreakpoints from '../../../../../helpers/customBreakpoints';
import { getLanguageName } from '../../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const styles = (theme) => ({
    root: {
        cursor: 'pointer',
        textDecoration: 'none',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            backgroundColor: theme.palette.white,
        },
        [theme.breakpoints.down('400px')]: {
            height: 'auto',
        },
        '& img': {
            overflow: 'hidden',
        },
        position: 'relative',
        marginBottom: '10px',
        display: 'inline-block',
        borderRadius: '2px',
    },
    productCopy: {
        color: theme.palette.black,
        fontSize: '13px',
        letterSpacing: '0.5px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        margin: '7px 0',
        textTransform: 'uppercase',
    },
    countryBlock: {
        display: 'inline-block',
        padding: '6px',
        verticalAlign: 'middle',
        height: '40px',
        backgroundColor: theme.palette.white,
        transform: 'translate(-50%, -50px)',
        maxWidth: '90%',
        position: 'absolute',
        left: '50%',
        bottom: '-35px',
        width: 'fit-content',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            width: '100%',
        },
    },
    countryFlagImage: {
        float: 'left',
        borderRadius: '50%',
        width: '30px',
        height: '30px',
        marginRight: '10px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            width: '20px',
            height: '20px',
            margin: '5px 5px 0 0',
        },
    },
    productImage: {
        width: '100%',
    },
});

const ProductUI = ({
    brand = {},
    classes,
    productData: {
        product_image = {},
        country_name = '',
        country_flag_logo = {},
        country_product_link: {
            href = '',
        },
    },
}) => {
    // @intention: pre-fetching PDP on mouseHover
    // query creation
    const FIND_URL_QUERY = findURL(brand.domain, `/${href}`);
    // functions to pre-fetch on mouseOver
    const [loadURL, { errorURL }] = useLazyQuery(FIND_URL_QUERY);
    if (errorURL) {
        mbpLogger.logError({
            message: 'TrendingProducts -> ProductUI.js - Failed to pre-fetch PDP using Apollo',
            errorURL,
        });
    }
    const languagePath = getLanguageName();
    return (
        <div>
            <Link
                className={classes.root}
                to={`${languagePath}${href}`}
                // pre-fetch
                onMouseEnter={() => {
                    loadURL();
                }}
            >
                <LazyLoad>
                    <img src={`${product_image?.url}`} className={classes.productImage} alt={country_name} />
                </LazyLoad>
                <div className={classes.countryBlock}>
                    <LazyLoad>
                        <img src={`${country_flag_logo?.url}`} className={classes.countryFlagImage} alt={country_name} />
                    </LazyLoad>
                    <p className={classes.productCopy}>
                        {country_name}
                    </p>
                </div>
            </Link>
        </div>
    );
};

ProductUI.propTypes = {
    brand: shape({
        domain: string,
    }).isRequired,
    classes: object.isRequired,
    productData: shape({
        product_image: shape({
            content_type: string,
            file_size: string,
            filename: string,
            is_dir: boolean,
            title: string,
            uid: string,
            url: string,
            parent_uid: string,
        }),
        country_name: string.isRequired,
        country_product_link: shape({
            title: string.isRequired,
            href: string.isRequired,
        }).isRequired,
        country_flag_logo: shape({
            content_type: string,
            file_size: string,
            filename: string,
            is_dir: boolean,
            title: string,
            uid: string,
            url: string,
            parent_uid: string,
        }),
    }).isRequired,
};

export default withStyles(styles)(ProductUI);
